import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteQuestionnaireMutation, deleteQuestionnaireMutationVariables } from '../generated/deleteQuestionnaireMutation';
import { questionnaireFieldsFragment } from '../models/Questionnaire';

/**
 * Get a callback to delete a Questionnaire in the store.
 */
export function useDeleteQuestionnaireCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteQuestionnaireMutation, deleteQuestionnaireMutationVariables>(
        gql`
            mutation deleteQuestionnaireMutation ($id: ID!) {
                deleteQuestionnaire(id: $id) {
                    ...questionnaireFields
                }
            }

            ${questionnaireFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
